import EN from './en';
import IT from './it';
import RU from './ru';

const DEFAULT_LOCALE = 'en';

export default class Translator {
  locale = DEFAULT_LOCALE;
  translations: { [key: string]: { [key: string]: string } };
  constructor() {
    this.translations = {};

    this.registerTranslation('en', EN);
    this.registerTranslation('it', IT);
    this.registerTranslation('ru', RU);

    let locale = null;
    const languages = Translator.getBrowserLanguages();
    for (let i = 0; i < languages.length; i++) {
      const lang = languages[i];
      if (this.translations.hasOwnProperty(lang)) {
        locale = lang;
        break;
      }
    }
    locale = locale ? locale : DEFAULT_LOCALE;

    this.setLocale(locale);
  }

  t(phrase: string, ...params: string[]) {
    return this.translate(phrase, ...params);
  }

  translate(phrase: string, ...params: string[]) {
    const locale = this.locale;

    const translation = this.translations[locale];
    if (!translation.hasOwnProperty(phrase)) {
      console.warn(`translation '${phrase}' not found in language '${locale}'`);
      return phrase;
    }

    let translatedPhrase = translation[phrase];

    translatedPhrase = translatedPhrase.replace(
      /{(\d+)}/g,
      function (match, number) {
        return typeof params[number] != 'undefined' ? params[number] : match;
      }
    );

    return translatedPhrase;
  }

  setLocale(locale: string) {
    locale = locale.toLowerCase();

    if (this.translations.hasOwnProperty(locale)) {
      this.locale = locale;
    } else {
      console.warn(
        `locale '${locale}' not available, switch to ${DEFAULT_LOCALE}`
      );
      this.locale = DEFAULT_LOCALE.toLowerCase();
    }
  }

  registerTranslation(locale: string, translations: Record<string, string>) {
    if (!this.translations.hasOwnProperty(locale)) {
      this.translations[locale] = translations;
    } else {
      Object.assign(this.translations[locale], translations);
    }
  }

  static getBrowserLanguages() {
    return navigator.languages
      ? navigator.languages
      : [navigator.language || (navigator as any).userLanguage];
  }
}
